<mat-sidenav-container fullscreen *ngIf="currentUser">
  <mat-sidenav
    mode="side"
    opened
    [ngClass]="!sideNavStatus ? 'toggleSizeIn' : 'toggleSizeOut'"
    class="sidenav"
  >
    <app-sidebar
      (titleEmitter)="getTitle($event)"
      [sideNavStatus]="sideNavStatus"
    ></app-sidebar>
    <div class="imagotipo" [ngClass]="!sideNavStatus?'showTooltip':'hideTooltip'">
      <div class="menu-item" [ngClass]="!sideNavStatus?'hideTop':'showTop'">
          <div class="logotipo" [ngClass]="!sideNavStatus?'hideToggle':'showToggle'">
          </div>
      </div>
  </div>
  </mat-sidenav>
  <mat-sidenav-content
    [ngClass]="!sideNavStatus ? 'contentIn' : 'contentOut'"
    class="mat-tab-body-content"
  >
    <mat-toolbar>
      <app-navbar
        [titleSection]="titleSection"
        (toggleSideNav)="onToggleSideNav($event)"
      >
      </app-navbar>
    </mat-toolbar>
    <app-footer></app-footer>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
  <mat-toolbar color="primary">
    <mat-toolbar-row></mat-toolbar-row>
  </mat-toolbar>
</mat-sidenav-container>
<app-login *ngIf="!currentUser"></app-login>
